import { Navigate, useParams } from 'react-router-dom';

/** 单段路径 /literature/:id 中不应视为文献 MongoId 的保留名 */
const RESERVED_IDS = new Set(['new', 'shared', 'notebook', 'category']);

/**
 * 旧「文献详情页」链接重定向到列表并打开检视抽屉（?inspect=id）
 */
const LiteratureInspectRedirect = () => {
  const { id } = useParams<{ id: string }>();
  if (!id || RESERVED_IDS.has(id)) {
    return <Navigate to="/literature" replace />;
  }
  return <Navigate to={`/literature?inspect=${encodeURIComponent(id)}`} replace />;
};

export default LiteratureInspectRedirect;
